import { Col, Row} from 'reactstrap';
import LabelField from '../../../components/LabelField';
import { useSelector } from 'react-redux';
import { checkNullValue, convertDate, convertWithoutTimezone, displayRatingValue } from '../../../utils/Util';
import TextAreaInput from '../../../components/TextAreaInput';

const FeedbackDetails = () => {
    const {
        storeGrievanceFeedbackInfo
    } = useSelector((state: any) => state.grievances);

    const feedbackData = storeGrievanceFeedbackInfo?.data;
    
    return (
        <>
            <Row>
                <Col xs={6} md={4} className="mb-3">
                    <LabelField name='Rating'></LabelField>
                    <p className='grievance-details'>{displayRatingValue(feedbackData?.rating)}</p>
                </Col>
                <Col xs={6} md={4} className="mb-3">
                    <LabelField name='Received At'></LabelField>
                    <p className='grievance-details'>{feedbackData?.uploadedAt ? convertDate(convertWithoutTimezone(feedbackData?.uploadedAt)) : 'N/A'}</p>
                </Col>
            </Row>
            <Row className="mb-3">
                <TextAreaInput
                    label={'Feedback Comments'}
                    style={{marginLeft: '1%'}}
                    value={checkNullValue(feedbackData?.comments)}
                    readOnly={true}
                    minrows={5}
                />
            </Row>
        </>
    );
}

export default FeedbackDetails;